<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        style="width: 100%" class="custom-tbl teacher-kq-tbl" height="100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="ScheduleName" label="规则名称"></el-table-column>
        <el-table-column prop="DepartmentName" label="所属机构"></el-table-column>
        <el-table-column prop="DeptNames" label="应用校区" min-width="160">
          <template slot-scope="scope">
            <el-button
              v-if="parseDeptNames(scope.row.DeptNames).length"
              type="text"
              size="small"
              icon="el-icon-office-building"
              class="kq-dept-link-btn"
              @click.stop="openDeptViewDialog(scope.row)">
              已选 {{ parseDeptNames(scope.row.DeptNames).length }} 个校区
            </el-button>
            <span v-else class="ac-empty-dash">-</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button class="table-op-link" type="text" size="small" @click.stop="ShowDailyTime(scope.row)">考勤时间</el-button>
              <el-button class="table-op-link" type="text" size="small" @click.stop="openEdit(scope.row)">编辑</el-button>
              <el-button class="table-op-link table-op-link--danger" type="text" size="small" @click.stop="handleDelRow(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="10" :total="total" style="float: right"></el-pagination>
      </el-col>

      <!-- 新增弹窗 -->
      <el-dialog title="新增教师考勤规则" :visible.sync="addFormVisible" width="520px" :close-on-click-modal="false">
        <el-form :model="addForm" :rules="formRules" ref="addForm" label-width="100px">
          <el-form-item label="规则名称" prop="ScheduleName">
            <el-input v-model="addForm.ScheduleName" placeholder="请输入规则名称"></el-input>
          </el-form-item>
          <el-form-item label="适用类型">
            <el-tag type="warning" size="small">教师（固定）</el-tag>
          </el-form-item>
          <el-form-item label="应用校区">
            <el-select v-model="addForm.campusIds" multiple clearable style="width: 100%"
              placeholder="请选择应用校区（可多选）" :loading="campusLoading">
              <el-option v-for="c in campusList" :key="c.value" :label="c.label" :value="c.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmit" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 编辑弹窗 -->
      <el-dialog title="编辑教师考勤规则" :visible.sync="editFormVisible" width="520px" :close-on-click-modal="false">
        <el-form :model="editForm" :rules="formRules" ref="editForm" label-width="100px">
          <el-form-item label="规则名称" prop="ScheduleName">
            <el-input v-model="editForm.ScheduleName" placeholder="请输入规则名称"></el-input>
          </el-form-item>
          <el-form-item label="适用类型">
            <el-tag type="warning" size="small">教师（固定）</el-tag>
          </el-form-item>
          <el-form-item label="应用校区">
            <el-select v-model="editForm.campusIds" multiple clearable style="width: 100%"
              placeholder="请选择应用校区（可多选）" :loading="campusLoading">
              <el-option v-for="c in campusList" :key="c.value" :label="c.label" :value="c.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 考勤时间列表弹窗 -->
      <el-dialog :title="dailyTimeTitle" :visible.sync="dailyTimeDialogVisible" width="700px"
        :close-on-click-modal="false">
        <div style="display: flex; justify-content: flex-end; gap: 8px; margin-bottom: 10px;">
          <el-button type="primary" @click="openDailyTimedialog(1)">新增</el-button>
          <el-button type="primary" @click="openDailyTimedialog(0)">编辑</el-button>
          <el-button type="danger" @click="delDailyTime()">删除</el-button>
        </div>
        <el-table :data="dailyTimeTitleData" @select="dailyTimeTitleCheck"
          @row-click="dailyTimeSelectCurrentRow" ref="dailyTimeTitleTable" class="custom-tbl" style="width: 100%">
          <el-table-column type="selection"></el-table-column>
          <el-table-column property="UsingWeekDayStr" label="日期"></el-table-column>
          <el-table-column property="TimeDataStr" label="时间设定"></el-table-column>
        </el-table>
        <div class="toolbar" style="text-align: right; padding: 10px 0;">
          <el-pagination layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentDailyTimeChange" :page-size="10" :total="dailyTimeTotal">
          </el-pagination>
        </div>
      </el-dialog>

      <!-- 每日考勤时间设定（嵌套弹窗，无自动考勤列） -->
      <el-dialog width="50%" title="每日考勤时间设定" :visible.sync="dailyTimeInnerVisible"
        append-to-body :close-on-click-modal="false" custom-class="daily-time-setting-dialog">
        <el-form label-width="80px">
          <div class="daily-time-table-wrap">
            <el-table border :data="tableData" class="daily-time-table" style="width: 100%">
              <el-table-column label="登记" width="100" align="center" header-align="center">
                <template slot-scope="scope">
                  <span>第{{ scope.$index + 1 }}次登记</span>
                </template>
              </el-table-column>
              <el-table-column label="考勤时间" min-width="500" align="center" header-align="center">
                <template slot-scope="scope">
                  <dailyForm :row="scope.row" @update:form="val => handleUpdateForm(val, scope.$index)" />
                </template>
              </el-table-column>
              <el-table-column label="类型" width="70" align="center" header-align="center">
                <template slot-scope="scope">
                  {{ (scope.$index + 1) % 2 == 0 ? '离开' : '进入' }}
                </template>
              </el-table-column>
              <!-- 教师版不显示自动考勤列 -->
            </el-table>
          </div>
          <el-form-item label="有效星期" class="daily-time-week-item">
            <el-checkbox-group v-model="usingWeekDays">
              <el-checkbox v-for="item in usingWeekDaysOptions" :key="item.value" :label="item.value"
                :disabled="item.disabled">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dailyTimeInnerVisible = false">取 消</el-button>
          <el-button type="primary" @click="savaDailyTimeSubmit" :loading="saveTimeLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 列表应用校区查看弹窗。最后更新：2026-09-08 -->
      <el-dialog :title="viewDeptDialog.title" :visible.sync="viewDeptDialog.visible" width="640px"
        :close-on-click-modal="false" append-to-body custom-class="kq-dept-view-dialog">
        <div class="kq-view-head">
          <div class="kq-view-head-item">
            <span class="label">规则：</span>
            <span class="val">{{ viewDeptDialog.scheduleName || '-' }}</span>
          </div>
          <div class="kq-view-head-item">
            <span class="label">机构：</span>
            <span class="val">{{ viewDeptDialog.departmentName || '-' }}</span>
          </div>
          <div class="kq-view-head-item">
            <span class="label">总数：</span>
            <span class="val count-badge">{{ viewDeptDialog.depts ? viewDeptDialog.depts.length : 0 }} 个校区</span>
          </div>
        </div>

        <div class="kq-view-toolbar">
          <el-input v-model="viewDeptDialog.filterKey" size="small" placeholder="搜索校区名称..." prefix-icon="el-icon-search"
            clearable class="kq-view-search-input" />
          <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllDeptNames">
            复制全部校区
          </el-button>
        </div>

        <div class="kq-view-table-wrap">
          <el-table :data="filteredViewDepts" size="small" max-height="340" border stripe class="kq-view-table">
            <el-table-column type="index" label="序号" width="70" align="center" />
            <el-table-column prop="name" label="校区名称" min-width="260">
              <template slot-scope="scope">
                <span class="dept-text">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleDeptName(scope.row.name)">复制</el-button>
              </template>
            </el-table-column>
            <div slot="empty" class="kq-view-empty">暂无匹配的校区</div>
          </el-table>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="viewDeptDialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>

    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getKqtScheduleTypeListPage, removeKqtScheduleType, editKqtScheduleType, addKqtScheduleType, getKqtScheduleDailySettingListPage, getDailyTime, removeKqtScheduleDailySetting, addKqtScheduleDailySetting } from '../../api/modules/attendance';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";
import { normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps';
import dailyForm from "../../components/dailyForm.vue";

const FIXED_ROLE = "teacher";

export default {
  components: { Toolbar, DepartmentPane, dailyForm },
  data() {
    return {
      filters: {},
      searchList: [{ label: "名称", key: "name" }],
      buttonList: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      campusLoading: false,
      campusList: [],
      campusListDepartmentId: 0,
      DepartmentId: 0,
      currentRow: null,
      addFormVisible: false,
      editFormVisible: false,
      addLoading: false,
      editLoading: false,
      addForm: { ScheduleName: "", DepartmentId: 0, UserRole: FIXED_ROLE, IsDefaultSchedule: false, campusIds: [] },
      editForm: { Id: 0, ScheduleName: "", UserRole: FIXED_ROLE, campusIds: [] },
      formRules: {
        ScheduleName: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
      },
      // 考勤时间
      dailyTimeDialogVisible: false,
      dailyTimeTitle: "",
      currentDailyTimeRow: null,
      dailyTimeInnerVisible: false,
      dailyTimeTitleData: [],
      dailyTimePage: 1,
      dailyTimeTotal: 0,
      tableData: [],
      dailyTimeRowCount: 6,
      saveTimeLoading: false,
      usingWeekDays: [],
      usingWeekDaysOptions: [
        { label: "星期一", value: "1", disabled: false },
        { label: "星期二", value: "2", disabled: false },
        { label: "星期三", value: "3", disabled: false },
        { label: "星期四", value: "4", disabled: false },
        { label: "星期五", value: "5", disabled: false },
        { label: "星期六", value: "6", disabled: false },
        { label: "星期日", value: "7", disabled: false },
      ],
      // 应用校区查看弹窗。最后更新：2026-09-08
      viewDeptDialog: {
        visible: false,
        title: '查看应用校区',
        scheduleName: '',
        departmentName: '',
        depts: [],
        filterKey: '',
      },
    };
  },
  computed: {
    // 弹窗过滤后的校区列表。最后更新：2026-09-08
    filteredViewDepts() {
      const list = this.viewDeptDialog.depts || [];
      const key = (this.viewDeptDialog.filterKey || '').trim().toLowerCase();
      if (!key) {
        return list.map((name) => ({ name }));
      }
      return list
        .filter((name) => String(name).toLowerCase().includes(key))
        .map((name) => ({ name }));
    },
  },
  methods: {
    // 解析校区/部门名为数组
    parseDeptNames(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return String(val).split(/[、,，;；]/).map(s => s.trim()).filter(s => s.length > 0);
    },
    // 打开应用校区查看弹窗。最后更新：2026-09-08
    openDeptViewDialog(row) {
      if (!row) return;
      const deptList = this.parseDeptNames(row.DeptNames);
      this.viewDeptDialog = {
        visible: true,
        title: `查看应用校区 - ${row.ScheduleName || '考勤规则'}`,
        scheduleName: row.ScheduleName || '',
        departmentName: row.DepartmentName || '',
        depts: deptList,
        filterKey: '',
      };
    },
    // 复制全部校区
    copyAllDeptNames() {
      const depts = (this.filteredViewDepts || []).map((item) => item.name).filter(Boolean);
      if (!depts.length) {
        this.$message.warning('暂无可复制的校区');
        return;
      }
      this.copyTextToClipboard(depts.join('、'));
      this.$message.success(`已复制 ${depts.length} 个校区名称`);
    },
    // 复制单个校区
    copySingleDeptName(text) {
      if (!text) return;
      this.copyTextToClipboard(text);
      this.$message.success(`已复制: ${text}`);
    },
    // 通用剪贴板复制工具
    copyTextToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('复制失败', err);
      }
      document.body.removeChild(textArea);
    },
    treeNodeClick(data) {
      const departmentId = normalizeDeptId(data.value);
      if (!deptIdsEqual(departmentId, this.DepartmentId)) {
        this.campusList = [];
        this.campusListDepartmentId = '';
        this.campusLoading = false;
      }
      this.DepartmentId = departmentId || data.value;
      this.handleQuery();
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectCurrentRow(row);
    },
    callFunction(item) {
      if (typeof item.search === "object") {
        this.filters = item.search;
      }
      this[item.Func] && this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleQuery() {
      const para = { page: this.page, departmentId: this.DepartmentId, userRole: FIXED_ROLE, ...this.filters };
      this.listLoading = true;
      getKqtScheduleTypeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },
    loadCampusList() {
      const departmentId = normalizeDeptId(this.DepartmentId);
      if (!departmentId) {
        this.campusList = [];
        this.campusListDepartmentId = '';
        return Promise.resolve();
      }
      if (deptIdsEqual(this.campusListDepartmentId, departmentId)) return Promise.resolve();
      this.campusLoading = true;
      return getCampusList({ page: 1, intPageSize: 999, departmentId }).then((res) => {
        if (!deptIdsEqual(this.DepartmentId, departmentId)) return;
        const list = res.data && res.data.success
          ? ((res.data.response && res.data.response.data) || [])
          : [];
        this.campusList = list.map((d) => ({ value: String(d.Id), label: d.Name }));
        this.campusListDepartmentId = departmentId;
        this.campusLoading = false;
      }).catch(() => {
        if (deptIdsEqual(this.DepartmentId, departmentId)) {
          this.campusList = [];
          this.campusListDepartmentId = '';
          this.campusLoading = false;
        }
      });
    },
    handleAdd() {
      this.loadCampusList();
      this.addForm = { ScheduleName: "", DepartmentId: this.DepartmentId || 0, UserRole: FIXED_ROLE, IsDefaultSchedule: false, campusIds: [] };
      this.addFormVisible = true;
    },
    handleEdit() {
      if (!this.currentRow) {
        this.$message({ message: "请选择要编辑的一行数据！", type: "error" });
        return;
      }
      this.openEdit(this.currentRow);
    },
    openEdit(row) {
      this.loadCampusList();
      const campusIds = (row.DeptIds || []).map((path) => path[path.length - 1]).filter(Boolean);
      this.editForm = { ...row, UserRole: FIXED_ROLE, campusIds };
      this.editFormVisible = true;
    },
    buildDeptIdStr(campusIds) {
      return (campusIds || []).join(",");
    },
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交吗？", "提示").then(() => {
          this.addLoading = true;
          const payload = { ...this.addForm, UserRole: FIXED_ROLE, DeptIdStr: this.buildDeptIdStr(this.addForm.campusIds) };
          addKqtScheduleType(payload).then((res) => {
            this.addLoading = false;
            if (res.data.success) {
              this.$message({ message: "新增成功", type: "success" });
              this.addFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({ message: res.data.msg, type: "error" });
            }
          });
        });
      });
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交吗？", "提示").then(() => {
          this.editLoading = true;
          const payload = { ...this.editForm, UserRole: FIXED_ROLE, DeptIdStr: this.buildDeptIdStr(this.editForm.campusIds) };
          editKqtScheduleType(payload).then((res) => {
            this.editLoading = false;
            if (res.data.success) {
              this.$message({ message: "修改成功", type: "success" });
              this.editFormVisible = false;
              this.handleQuery();
            } else {
              this.$message({ message: res.data.msg, type: "error" });
            }
          });
        });
      });
    },
    handleDelRow(row) {
      this.$confirm("确认删除该规则吗？", "提示", { type: "warning" }).then(() => {
        removeKqtScheduleType({ id: row.Id }).then((res) => {
          if (res.data.success) {
            this.$message({ message: "删除成功", type: "success" });
            this.handleQuery();
          } else {
            this.$message({ message: res.data.msg, type: "error" });
          }
        });
      });
    },
    handleDel() {
      if (!this.currentRow) {
        this.$message({ message: "请选择要删除的一行数据！", type: "error" });
        return;
      }
      this.handleDelRow(this.currentRow);
    },

    // ===== 考勤时间管理 =====
    ShowDailyTime(row) {
      this.currentRow = row;
      this.currentDailyTimeRow = null;
      this.dailyTimeTitle = row.ScheduleName + " - 考勤时间列表";
      this.dailyTimeDialogVisible = true;
      this.dailyTimeHandleQuery();
    },
    dailyTimeTitleCheck(selection, row) {
      this.currentDailyTimeRow = null;
      this.$refs.dailyTimeTitleTable.clearSelection();
      if (selection.length === 0) return;
      if (row) this.dailyTimeSelectCurrentRow(row);
    },
    dailyTimeSelectCurrentRow(val) {
      if (val) {
        this.currentDailyTimeRow = val;
        this.$refs.dailyTimeTitleTable.clearSelection();
        this.$refs.dailyTimeTitleTable.toggleRowSelection(val, true);
      }
    },
    handleCurrentDailyTimeChange(val) {
      this.dailyTimePage = val;
      this.dailyTimeHandleQuery();
    },
    dailyTimeHandleQuery() {
      const para = { page: this.dailyTimePage, scheduleTypeId: this.currentRow.Id };
      getKqtScheduleDailySettingListPage(para).then((res) => {
        this.dailyTimeTotal = res.data.response.dataCount;
        this.dailyTimeTitleData = res.data.response.data;
      });
    },
    openDailyTimedialog(type) {
      if (type == 1) {
        this.currentDailyTimeRow = null;
        if (this.$refs.dailyTimeTitleTable) this.$refs.dailyTimeTitleTable.clearSelection();
      }
      const row = this.currentDailyTimeRow;
      if (type == 0 && !row) {
        this.$message({ message: "请选择要编辑的一行数据！", type: "error" });
        return;
      }
      const para = {
        scheduleTypeId: this.currentRow.Id,
        dailySettingId: type == 0 ? (row ? row.Id : "") : "",
      };
      this.tableData = [];
      getDailyTime(para).then((res) => {
        if (res.data.success) {
          this.usingWeekDays = res.data.response.UsingWeekDays;
          this.usingWeekDaysOptions = res.data.response.UsingWeekDaysOptions;
          this.tableData = this.normalizeDailyTimeData(res.data.response.TimeData);
          this.dailyTimeInnerVisible = true;
        } else {
          this.$message({ message: res.data.msg, type: "error" });
        }
      });
    },
    normalizeDailyTimeData(timeData) {
      const normalizedData = (timeData || []).map((item) => ({
        ...item,
        start: item && item.start ? item.start : "",
        ontime: item && item.ontime ? item.ontime : "",
        end: item && item.end ? item.end : "",
        isAutoKaoqin: false,
      }));
      const emptyRows = Array.from({ length: this.dailyTimeRowCount }, () => ({
        start: "", ontime: "", end: "", isAutoKaoqin: false,
      }));
      return [...normalizedData, ...emptyRows].slice(0, this.dailyTimeRowCount);
    },
    delDailyTime() {
      const row = this.currentDailyTimeRow;
      if (!row) {
        this.$message({ message: "请选择要删除的一行数据！", type: "error" });
        return;
      }
      this.$confirm("确认删除该记录吗？", "提示", { type: "warning" }).then(() => {
        removeKqtScheduleDailySetting({ id: row.Id }).then((res) => {
          if (util.isEmt.format(res)) return;
          if (res.data.success) {
            this.$message({ message: "删除成功", type: "success" });
          } else {
            this.$message({ message: res.data.msg, type: "error" });
          }
          this.dailyTimeHandleQuery();
        });
      }).catch(() => {});
    },
    savaDailyTimeSubmit() {
      if (this.usingWeekDays.length == 0) {
        this.$message({ message: "请选择有效星期", type: "error" });
        return;
      }
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        this.saveTimeLoading = true;
        const saveData = {
          scheduleTypeId: this.currentRow.Id,
          timeData: this.tableData,
          usingWeekDays: this.usingWeekDays,
          dailySettingId: this.currentDailyTimeRow == null ? "" : this.currentDailyTimeRow.Id,
        };
        addKqtScheduleDailySetting(saveData).then((res) => {
          this.saveTimeLoading = false;
          if (util.isEmt.format(res)) return;
          if (res.data.success) {
            this.$message({ message: res.data.msg, type: "success" });
            this.dailyTimeInnerVisible = false;
            this.dailyTimeHandleQuery();
          } else {
            this.$message({ message: res.data.msg, type: "error" });
          }
        });
      });
    },
    handleUpdateForm(val, index) {
      this.$set(this.tableData, index, { ...this.tableData[index], ...val });
    },
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style>
/* 教师考勤规则列表校区查看按钮与弹窗。最后更新：2026-09-08 */
.kq-dept-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.kq-dept-link-btn:hover,
.kq-dept-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

.ac-empty-dash {
  color: #9ca3af;
  font-size: 14px;
}

.kq-dept-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.kq-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.kq-view-head-item {
  font-size: 13px;
  color: #334155;
}

.kq-view-head-item .label {
  color: #64748b;
}

.kq-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.kq-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.kq-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.kq-view-search-input {
  max-width: 280px;
}

.kq-view-table-wrap {
  border-radius: 4px;
  overflow: hidden;
}

.kq-view-table .dept-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}

.kq-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}
</style>
